import axios from "axios";
import config from "../../../config";

const getGpsListStart = () => {
  return {
    type: "GET_GPS_LIST_START",
  };
};

const getGpsListSuccess = ({ data }) => {
  return {
    type: "GET_GPS_LIST_SUCCESS",
    data,
  };
};

const getGpMetricsFail = () => {
  return {
    type: "GET_GP_METRICS_FAIL",
  };
};

const getGpMetricsStart = () => {
  return {
    type: "GET_GP_METRICS_START",
  };
};

const getGpMetricsSuccess = ({ data }) => {
  return {
    type: "GET_GP_METRICS_SUCCESS",
    data,
  };
};

const getGpsListFail = () => {
  return {
    type: "GET_GPS_LIST_FAIL",
  };
};

export function getGpsList() {
  return (dispatch, getState) => {
    dispatch(getGpsListStart());

    const { login } = getState();

    axios
      .get(`${config.API_URL}/gps/all`, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        dispatch(getGpsListSuccess({ data: resp.data }));
      })
      .catch((ex) => {
        console.log("Failed to post user", ex);
        dispatch(getGpsListFail());
      });
  };
}

export function getGpMetrics(gpId) {
  return (dispatch, getState) => {
    dispatch(getGpMetricsStart());

    const { login } = getState();

    axios
      .get(`${config.API_URL}/gps/${gpId}/metrics`, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        console.log(resp, "responsessss");
        dispatch(getGpMetricsSuccess({ data: resp.data }));
      })
      .catch((ex) => {
        console.log("Failed to get Fund metrics", ex);
        dispatch(getGpMetricsFail());
      });
  };
}

// Send reminder
export const sendReminder = (lpId, ccPartner) => {
  return (dispatch, getState) => {
    dispatch({
      type: "SEND_REMINDER_LOADING",
      payload: true,
    });

    const { login } = getState();
    axios
      .post(
        `${config.API_URL}/gps/${lpId}/reminder`,
        {
          ccPartner,
        },
        {
          headers: {
            Authorization: `Bearer ${login.token}`,
          },
        }
      )
      .then((resp) => {
        dispatch({
          type: "SEND_REMINDER",
          payload: resp.data,
        });
      })
      .catch((ex) => {
        console.log("Failed to send reminder", ex);
        dispatch({
          type: "SEND_REMINDER",
          payload: ex,
          error: true,
        });
      });
  };
};

export const resetReminderStatus = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_REMINDER_STATUS", payload: false });
  };
};
